module.exports = __webpack_public_path__ + "static/media/genesis_logo.cd213dc7.jpg";